









import { Component, Vue, Prop } from 'vue-property-decorator';
import { NavigationTab } from '@/interfaces/registration/NavigationTab';
import { namespace } from 'vuex-class';
const navigation = namespace('navigation');

@Component
export default class RegistrationHeaderTab extends Vue {
  @Prop() readonly navigationTab!: NavigationTab;

  @navigation.Getter
  public currentTab!: NavigationTab;

  public tabIcon () {
    if (this.currentTab.panelComponent === this.navigationTab.panelComponent) {
      return 'fas fa-check-circle';
    }

    if (this.navigationTab.completed && this.currentTab.panelComponent !== this.navigationTab.panelComponent) {
      return 'fas fa-check';
    }

    return 'far fa-check-circle';
  }
}
